import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav style={{
      backgroundColor: "#2d6a4f",
      padding: "10px 20px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }}>
      <h2 style={{ color: "white" }}>FreshHarvest</h2>
      <div>
        <Link to="/" style={{ color: "white", margin: "0 10px", textDecoration: "none" }}>Home</Link>
        <Link to="/shop" style={{ color: "white", margin: "0 10px", textDecoration: "none" }}>Shop</Link>
        <Link to="/about" style={{ color: "white", margin: "0 10px", textDecoration: "none" }}>About</Link>
        <Link to="/cart" style={{ color: "white", margin: "0 10px", textDecoration: "none" }}>Cart</Link>
      </div>
    </nav>
  );
};

export default Navbar;
